import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=4a08e5bc&scoped=true&"
import script from "./NotificationComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&id=4a08e5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08e5bc",
  null
  
)

export default component.exports